import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { Dropdown, Tooltip } from 'antd';
import SimpleDropdownContent, { Item } from '../dropdown/SimpleDropdownContent';
import { CaretDownFilled } from '@ant-design/icons';
import { selectOrganization } from 'v2/store/organizationList/actions/SelectOrganization';
import './OrganizationSelector.scss';
import { t } from 'helpers/i18n';

const OrganizationSelector: React.FC = () => {
  const dispatch = useDispatch();
  const { organizations, selectedOrganization } = useSelector(
    (state: RootState) => state.organizationList
  );

  const [organizationDropdownItems, setOrganizationDropdownItems] = useState<
    Item[]
  >([]);

  const [openDropdown, setOpenDropdown] = useState(false);
  const handleOpenDropdownChange = (open: boolean) => {
    setOpenDropdown(open);
  };

  useEffect(() => {
    let displayOrganizations = [...organizations];
    displayOrganizations = displayOrganizations.sort((a, b) =>
      a.name.localeCompare(b.name)
    );
    if (selectedOrganization) {
      displayOrganizations.every((item, index) => {
        if (item.id === selectedOrganization.id) {
          displayOrganizations.splice(index, 1);
          displayOrganizations.unshift(item);
          return false;
        }

        return true;
      });
    }

    setOrganizationDropdownItems(
      displayOrganizations.map(item => ({
        key: item.id.toString(),
        label: item.name,
      }))
    );
  }, [organizations, selectedOrganization]);

  if (organizations.length === 0) {
    return <div />;
  }

  if (organizations.length === 1) {
    return (
      <div className="organization-selector-container">
        <Tooltip title={t('your_organization')}>
          <p className="organization-selector-organization-name">
            {selectedOrganization?.name}
          </p>
        </Tooltip>
      </div>
    );
  }

  const onSelectOrganizationItem = (key: string) => {
    const organizationId = parseInt(key);
    const selectedOrganization = organizations.find(
      item => item.id === organizationId
    );
    if (selectedOrganization) {
      dispatch(selectOrganization(selectedOrganization));
      handleOpenDropdownChange(false);
    }
  };

  return (
    <Dropdown
      trigger={['click']}
      onOpenChange={handleOpenDropdownChange}
      open={openDropdown}
      destroyPopupOnHide
      overlay={() => (
        <SimpleDropdownContent
          items={organizationDropdownItems}
          selectedItemKey={selectedOrganization?.id?.toString()}
          onSelect={onSelectOrganizationItem}
        />
      )}
    >
      <div className="organization-selector-container">
        <p className="organization-selector-organization-name">
          {selectedOrganization?.name}
        </p>
        <CaretDownFilled
          sizes="24"
          className="organization-selector-right-icon"
        />
      </div>
    </Dropdown>
  );
};

export default memo(OrganizationSelector);
